"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StudentProfileIncidentParticipantListResponse = void 0;
const mappable_base_1 = require("../../mappable.base");
const enums_1 = require("../../enums");
const class_transformer_1 = require("class-transformer");
class StudentProfileIncidentParticipantListResponse extends mappable_base_1.MappableBase {
    constructor(options) {
        super();
        if (options)
            Object.assign(this, options);
    }
    getFields() {
        return ['type', 'incidentNumber', 'incidentId', 'referralStatus', 'incidentDate', 'incidentDescription'];
    }
    type;
    incidentNumber;
    incidentId;
    referralStatus;
    incidentDate;
    incidentDescription;
}
exports.StudentProfileIncidentParticipantListResponse = StudentProfileIncidentParticipantListResponse;
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], StudentProfileIncidentParticipantListResponse.prototype, "type", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], StudentProfileIncidentParticipantListResponse.prototype, "incidentNumber", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], StudentProfileIncidentParticipantListResponse.prototype, "incidentId", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], StudentProfileIncidentParticipantListResponse.prototype, "referralStatus", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Date)
], StudentProfileIncidentParticipantListResponse.prototype, "incidentDate", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], StudentProfileIncidentParticipantListResponse.prototype, "incidentDescription", void 0);
